<template>

    <div class="document-block">
        <h4 class="title"><a v-bind:href="apiDomain" target="_blank"><i class="fa fa-file-pdf-o"></i>{{ document.title }}</a></h4>
        <!-- <div class="date">{{ document.updatedAt | formatDate }}</div> -->
        <span class="toolbar" v-if="sharingEnabled">
            <a href="#" class="action" @click.prevent="updateSelected"><i class="fa fa-square-o"></i></a>
            <!-- <a href="#" class="action"><i class="fa fa-trash-o"></i></a> -->
            <!-- <a href="#" class="action"><i class="fa fa-gear"></i></a> -->
        </span>
    </div>

</template>



<script>

    import APIService from '@/services/api.service'
    import { Store } from '@/store.js'

    export default {

        name: 'documentItem',
        
        props: ['document', 'sharingEnabled'],
        
        data() {
            return {
                store: Store
            }
        },
        
        computed : {
            apiDomain: function() {
                return APIService.baseURL + this.document.documentFileUrl;// + '&X_LEWIS_RICE_API_KEY_OTHER=' + this.store.data.user.apiKey;
            }
        },
        
        methods: {

            updateSelected: function(evt) {
                $(evt.currentTarget).toggleClass('selected')
                $(evt.currentTarget).children('i').toggleClass('fa-square-o fa-check-square-o')
                this.document.selected = ($(evt.currentTarget).hasClass('selected'))
            }
        }
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    .document-block {
        text-align: left;
        margin-bottom: 1em;
        position: relative;
        padding: 0 2em 0 2em;

        h4 {
            margin: 0;
            font-weight: normal;
            line-height: 1.2;

            a img {
                position: absolute;
                left: 0;
                top: 0;
                height: 1.5em;
            }

            a i {
                position: absolute;
                left: 0;
                top: 0;
                font-size: 1.3em;
            }
        }

        .date {
            margin-bottom: 0;
            font-size: 0.8em;
            color: #999;
            position: relative;
            top: 0em;
        }

        .toolbar {
            position: absolute;
            right: 0;
            top: -0.4em;
            font-size: 1.3em;
            font-weight: normal;
            width: 1em;

            a {
                display: inline-block;
                color: darken(#eee, 30%);
                font-size: 1.2em;
                cursor: pointer;
            }

            .selected {
                color: $brand-blue-bright;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// DocumentItem.vue?185741de